<template>
  <div class="i-text-field-wrapper" v-on-clickaway="commit">
    <input
      ref="inputRef"
      type="text"
      v-model="inputModel"
      :readonly="!editMode"
      @keydown.escape.stop.prevent="() => { cancel(); focusEditButton(); }"
      @keydown.enter.stop.prevent="() => { commit(); focusEditButton(); }"
      v-bind="$attrs"
    />
    <a
      ref="editButtonRef"
      v-show="!editMode && !readonly"
      href="#"
      :title="LANG.edit"
      @click.prevent="enableEdit"
    >
      <i class="fas fa fa-pencil-alt"></i>
    </a>
  </div>
</template>

<script>
import { directive as onClickaway } from 'vue3-click-away';
import { mapState } from 'vuex';

export default {
  name: 'i-text-field-editable',
  directives: {
    onClickaway,
  },
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      editMode: false,
      inputModel: '',
    };
  },
  computed: {
    ...mapState(['LANG']),
  },
  methods: {
    enableEdit() {
      if (this.readonly) return;

      this.editMode = true;
      this.focusInput();
    },
    commit() {
      if (!this.editMode || this.readonly) return;

      this.$emit('update:modelValue', this.inputModel);
      this.editMode = false;
    },
    cancel() {
      if (!this.editMode || this.readonly) return;

      this.inputModel = this.modelValue;
      this.editMode = false;
    },
    focusInput() {
      const { inputRef } = this.$refs;
      if (!inputRef) return;

      this.$nextTick(() => inputRef.focus());
    },
    focusEditButton() {
      const { editButtonRef } = this.$refs;
      if (!editButtonRef) return;

      this.$nextTick(() => editButtonRef.focus());
    },
  },
  watch: {
    // NOTE: sync the internal state to the model
    modelValue: {
      immediate: true,
      handler(value) {
        this.inputModel = value;
      },
    },
  },
};
</script>

<style scoped lang="scss">
.i-text-field-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
input {
  flex-grow: 1;
  border: 1px solid #9e9e9e;
  border-radius: 0;
  color: #333;
  font-family: $font-family-light;
  font-size: 13px;
  font-weight: normal;
  height: 28px;
  line-height: 28px;
  outline: none;
  padding-left: 7px;
  background: #fff;
}
input:read-only {
  border-color: transparent;
  padding-left: 0px;
  background: transparent;
  box-shadow: none;
  cursor: default;
}
input::placeholder {
  color: $black;
  opacity: 1; // FF fix
}
a {
  color: $blue;
}
</style>
